import isFullArray from "./isFullArray";

export default price => {
  if (isFullArray(price)) {
    return price * 100;
  }
  return price;
};
